import { z } from "zod";

const JacobBearCalculationRowSchema = z.object({
  iJB: z.number(),
  tJB: z.number().positive(),
  gradi: z.number(),
});

export const JacobBearRequestSchema = z.object({
  parameters: z.array(JacobBearCalculationRowSchema),
});

export type JacobBearRequest = z.infer<typeof JacobBearRequestSchema>;
